import { Card } from 'react-bootstrap';

export default function Cards({skills}) {

	const { title } = skills; 
	return(		 
       <Card className="cardSkills mb-2">
            <Card.Body>
                <Card.Title>
                    <h5 className="text-center">{title}</h5>
                </Card.Title>
            </Card.Body>
 	   </Card>	 	   
	);
}; 